import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

/**
 * Component for displaying change icon with tooltip
 *
 * __Inputs__
 * - {@link ents.core.display.Metric.Change | change}!
 *
 * @example
 * ```html
 * <metric-change [change]="changeSg()" />
 * ```
 */
@ngCore.Component({
  imports: [ds.tooltip.Directive],
  selector: 'metric-change',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * @see {@link ents.core.display.Metric.Change}
   */
  public readonly changeSg =
    ngCore.input.required<ents.core.display.Metric.Change>({
      alias: 'change',
    })

  /**
   * Exposing {@link ents.core.display.Metric.Change.Direction} to HTML
   */
  public readonly DirectionEnum = ents.core.display.Metric.Change.Direction
  /**
   * Exposing {@link ents.core.common.Quality} to HTML
   */
  public readonly QualityEnum = ents.core.common.Quality
}
